var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notification-create-form',{on:{"completed":_vm.onCompleted}}),_c('notification-list',{on:{"update":_vm.onUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }